import '../../pages/Forgetpass/Forgetpass.css';
import './Pop.css';
import '../../component/layouts/Style.css';
import React, { useContext, useState } from 'react';


import { Container, Row, Col } from 'reactstrap';
import { AppContext } from '../../context/AppContext';
import PortalWrapper from "./PortalWrapper"; 
import { Link } from 'react-router-dom';


const ForgetPop = ({ onClose, onSwitchToRegister }) => {
  // const navigate = ();
  const { setToken, setShowLogin, setShowRegister } = useContext(AppContext);

  const [message, setMessage] = useState(null);
  
  const handleSubmit = async (e) => {
  e.preventDefault();
  const email = e.target.email.value;

  try {
    const response = await fetch('https://dashboard.tiktaka.com/api/forgot-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email })
    });
    const data = await response.json();
    setMessage(data.message);
    // alert(data.message);
  } catch (err) {
    alert("Error sending reset link");
  }
};

  return (
    <PortalWrapper>
      <div className="popup-overlay">
        <div className="popup-panel">
          <div className="panel-header">
            <button onClick={onClose}>✖</button>
          </div>
          <div className="panel-body">
            <section>
                <Container>
                    <Row>
                        <Col lg='6' md='6' sm='12' className='loginBox'>


                            {/* <Col lg='6' md='6' sm='12' className='loginBox'> */}
                        <form onSubmit={handleSubmit} className='material-form'>
                          <span style={{ color:'red' }} > { message }</span> 
                            <div className='input-field'>
                                <input type='text' placeholder='email' name='email'></input>
                                <label>Email</label>
                                <span className="bar"></span>
                              
                            </div>

                          

                            <button type='submit'>Submit</button>

                          <div className='rememberForget'>
                              
                              <Link to="#" onClick={(e) => { 
                              e.preventDefault(); 
                              onClose(); 
                              setShowRegister(true); 
                            }}>Create new account</Link>
                                /
                              <Link to="#" onClick={(e) => { 
                              e.preventDefault(); 
                              onClose(); 
                              setShowLogin(true); 
                            }}>Login</Link>
                          </div>
                        </form>
                        </Col>
                    </Row>
                </Container>
            </section>
          </div>
        </div>
      </div>
    </PortalWrapper>
  );
};

export default ForgetPop;
